// Shared types consumed by api, web, and mobile.
// Tables here mirror packages/api/src/db/schema.* once it's authored;
// keep names aligned with .claude/skills/database-schema.md.
/**
 * How a time entry bills — the ONE rule every invoice, preview, WIP and
 * retainer path uses (migration 0057). A flat fee bills once, at the entry's
 * own fee when it has one; an hourly entry bills hours × rate. `rateAmount` is
 * whatever rate the caller prices from (the project's effective rate on an
 * invoice, the stored rate for the retainer debit).
 */
export function timeEntryBilling(entry, rateAmount) {
    if (entry.rate_type === 'flat_fee') {
        return { quantity: '1', unit_amount: entry.flat_amount ?? rateAmount };
    }
    return { quantity: entry.hours ?? '0', unit_amount: rateAmount };
}
export const US_STATES = [
    { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' }, { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' }, { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' }, { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' }, { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' }, { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' }, { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' }, { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' },
    { code: 'PR', name: 'Puerto Rico' },
];
const STATE_LOOKUP = (() => {
    const m = {};
    for (const s of US_STATES) {
        m[s.name.toLowerCase()] = s.code;
        m[s.code.toLowerCase()] = s.code;
    }
    return m;
})();
/** Normalize a free-text state ("California" / "ca" / "CA") to its 2-letter
 *  code. Unknown values fall back to the first two letters uppercased. NULL/
 *  blank → null. Shared by the address state dropdown and the vCard importer. */
export function normalizeStateCode(raw) {
    if (!raw)
        return null;
    const t = raw.trim();
    if (t === '')
        return null;
    return STATE_LOOKUP[t.toLowerCase()] ?? t.toUpperCase().slice(0, 2);
}
/** Raster image MIME types accepted for contact photos. SVG is deliberately
 *  excluded — an inline-served SVG can execute script (stored XSS). */
export const PHOTO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export function isAllowedPhotoMime(m) {
    return PHOTO_MIME_TYPES.includes(m);
}
// Re-export point for future per-domain modules.
// export * from './evidence.js';
// export * from './invoice.js';
// export * from './audit.js';
//# sourceMappingURL=index.js.map